import { SearchDisplayGroups, SearchDisplayGroupsVariables } from './__generated__/SearchDisplayGroups'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

export const SEARCH_DISPLAY_GROUPS_QUERY = gql`
  query SearchDisplayGroups($input: SearchDisplayGroupsInputV2) {
    searchDisplayGroups: searchDisplayGroupsV2(input: $input) {
      ... on SearchDisplayGroupsV2 {
        displayGroups {
          id
          title
          ownerName
          ownerEmail
          boards {
            id
            onlineStatus
            firmwareVersion
          }
          displayDelay
          createdAt
          updatedAt
          deletedAt
          columns
          rows
          plusExpiresAt
        }
        nextCursor
      }
      ... on DisplayGroupErrorV2 {
        type
        error
      }
    }
  }
`

export const useSearchDisplayGroups = (variables: SearchDisplayGroupsVariables) => {
  return useQuery<SearchDisplayGroups, SearchDisplayGroupsVariables>(SEARCH_DISPLAY_GROUPS_QUERY, {
    variables,
    fetchPolicy: 'network-only'
  })
}
